export const noop = (): void | Promise<void> => {
  // noop
};
